import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { toast } from 'sonner';
import { useAuth } from '@/shared/lib/auth';
import { legacy } from '@/shared/api/client';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/shared/ui/card';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';
import { Button } from '@/shared/ui/button';

const schema = z
  .object({
    password: z.string().min(6, 'Mínimo 6 caracteres'),
    confirm: z.string(),
  })
  .refine((d) => d.password === d.confirm, { message: 'Senhas não conferem', path: ['confirm'] });

type FormValues = z.infer<typeof schema>;

export function AccountPasswordPage() {
  const { user } = useAuth();
  const form = useForm<FormValues>({ resolver: zodResolver(schema) });

  const onSubmit = form.handleSubmit(async (values) => {
    if (!user) return;
    try {
      await legacy.post('/change_password', { iduser: user._id, password: values.password });
      toast.success('Senha alterada com sucesso.');
      form.reset();
    } catch {
      toast.error('Falha ao alterar senha.');
    }
  });

  return (
    <Card className="max-w-md">
      <CardHeader>
        <CardTitle>Alterar senha</CardTitle>
        <CardDescription>Escolha uma senha forte para sua conta.</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">Nova senha</Label>
            <Input id="password" type="password" autoComplete="new-password" {...form.register('password')} />
            {form.formState.errors.password && (
              <p className="text-sm text-destructive">{form.formState.errors.password.message}</p>
            )}
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm">Confirmar senha</Label>
            <Input id="confirm" type="password" autoComplete="new-password" {...form.register('confirm')} />
            {form.formState.errors.confirm && (
              <p className="text-sm text-destructive">{form.formState.errors.confirm.message}</p>
            )}
          </div>
          <Button type="submit" loading={form.formState.isSubmitting}>Salvar senha</Button>
        </form>
      </CardContent>
    </Card>
  );
}
